<script>
    import Library from '../../Models/libraryORM'
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import parseFields from '../../Utilities/parseFields';

    let selected_library_id;

    let library_items;
    let library_sortFields;
    let library_unsub;

    let libraries = Library.getList();

    function getLibraryData(lib_id) {
        if (!lib_id) return;

        if (library_unsub) {
            // unsubscribe from previous library
            library_unsub();
            library_unsub = undefined;
        }

        let library_model = new Library(lib_id);

        library_unsub = library_model.store.subscribe((lib) => {
            if (!lib) return;

            library_sortFields = parseFields(lib.fields).sortFields;

            library_items = lib.items.items;
        })
    }

    export let cancelAction;
    export let saveAction;

    // we don't use the delete action
    // but putting it here to suppress warning
    export let deleteAction;

    $:getLibraryData(selected_library_id);
</script>

<Loader loading={!$libraries}>
<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-fullwidth">
        <header class="modal-card-head">
            <p class="modal-card-title">Create Mapping</p>
            <button class="delete" aria-label="close" on:click={cancelAction}></button>
        </header>
        <section class="modal-card-body">
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <span class="label">Library</span>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control select is-fullwidth">
                            <select bind:value={selected_library_id}>
                                {#each $libraries as library}
                                    <option value={library._id}>{library.name}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            {#if selected_library_id}
            <div>
                <SortableTable sortFields={library_sortFields} tableData={library_items} ORM="true">
                    <div slot="rowActions" let:row={item}>
                        <div class="button is-success" on:click={() => saveAction({
                            type: "library_item",
                            library_id: selected_library_id,
                            id: item.details._id
                        })}>
                            Map Item
                        </div>
                    </div>
                </SortableTable>
            </div>
            {/if}
        </section>
    </div>
</div>
</Loader>